import { render, staticRenderFns } from "./ProvideValueEffect.vue?vue&type=template&id=514af77a&"
import script from "./ProvideValueEffect.vue?vue&type=script&lang=ts&"
export * from "./ProvideValueEffect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports